import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import styled from 'styled-components'

import {Box, Card, Flex, Text} from 'rebass';
import moment from 'moment'
import Truncate from 'react-truncate';

import {withFirebase} from "../Firebase";
import {Backdrop, Block, Overlay} from "reakit";
import PostDetails from '../../pages/PostDetails';


const TitleLink = styled(Link)`
  text-decoration: none;
  color: #263039;
  padding: 0;
  margin: 0;
`;

const Wrapper = styled(Flex)`
min-height: 90px;
`

class PinnedPost extends Component {
	constructor(props) {
		super(props);
		this.state = {
			owner: {first_name: '', last_name: '', id: 1},
			open: false,
			faculty: [],
			loading: true,
			width: 0, height: 0,
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentDidMount() {
		//this.fetchOwnerInfo()
		//this.fetchFacultyList();
		window.addEventListener('resize', this.updateWindowDimensions);
		this.updateWindowDimensions();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
		this.updateWindowDimensions();
	}

	updateWindowDimensions() {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	}

	fetchOwnerInfo = async () => {
		const {post, firebase} = this.props;
		try {
			if (post.creator_is_student) {
				let studentRef = await firebase.student(post.creator_uid).get();

				const data = {id: studentRef.id, ...studentRef.data()};
				this.setState({owner: data})
			} else {
				let studentRef = await firebase.faculty(post.creator_uid).get();

				const data = {id: studentRef.id, ...studentRef.data()};
				this.setState({owner: data})
			}
		} catch (e) {
			console.log(e)
		}
	};

	fetchFacultyList = async () => {
		try {
			let faculty = [];
			let facultyRef = await this.props.firebase.faculties().get();
			facultyRef.docs.forEach(doc => faculty.push({id: doc.id, ...doc.data()}));
			this.setState({faculty, loading: false})
		} catch (error) {
			console.log(error)
		}
	};

	toggleOpen = () => {
		const {open} = this.state;
		this.setState({open: !open})
	}

	renderModalData = () => {
		const {post} = this.props;
		const { loading, faculty, open} = this.state;

		return (
			<Overlay.Container>
				{overlay => (
				<Block>
					<Backdrop fade use={Overlay.Hide} {...overlay} visible={open} onClick={this.toggleOpen}/>
					<Overlay fade slide {...overlay} visible={open} width={'80vw'}>
						<Flex flexDirection={'column'} justifyContent={'space-between'}>
							<PostDetails {...this.props} post={post} faculty={faculty} loading={loading} />
						</Flex>
					</Overlay>
				</Block>
			)}
			</Overlay.Container>
		);
	}

	render() {
		const {owner} = this.state;
		const {post, profile} = this.props;
		const date = moment.unix(post.post_time).calendar();
		let name = owner.first_name + ' ' + owner.last_name;
		if (post.creator_uid === profile.id) {
			name = 'Me'
		}
		if (this.state.width <= 768 ) {
			return (
				<TitleLink to={`/app/posts/${post.id}`}>
				<Card variant='pinned' p={1} mr={2} width={['300px']}>
					<Wrapper width={1} justifyContent={'space-between'}  flexDirection={'column'} flexWrap={'wrap'}>
						<Box pt={'5px'}>
						</Box>
						<Flex justifyContent={'center'} flexWrap={'wrap'} flexDirection={'column'}>
							<Text ml={['2px', '6px']} py={2} fontSize={'17px'} fontWeight={800}>
								<Truncate
									lines={1}
								>
									{post.title}
								</Truncate>
							</Text>
						</Flex>
						<Box pb={3}>
							<Text ml={['3px', '6px']} p={0} pb={'2px'} fontSize={'10px'}  fontWeight={600}>{name}</Text>
							<Text ml={['3px', '6px']}  fontSize={'10px'} fontWeight={600} color={'metaText'}>{date}</Text>
						</Box>
					</Wrapper>
				</Card>
			</TitleLink>
			);
		} else {
		
			return (
				<div>
					<TitleLink onClick={this.toggleOpen}>
						<Card variant='pinned' p={1} mr={2} width={['300px']}>
							<Wrapper width={1} justifyContent={'space-between'}  flexDirection={'column'} flexWrap={'wrap'}>
								<Box pt={'5px'}>
								</Box>
								<Flex justifyContent={'center'} flexWrap={'wrap'} flexDirection={'column'}>
									<Text ml={['2px', '6px']} py={2} fontSize={'17px'} fontWeight={800}>
										<Truncate
											lines={1}
										>
											{post.title}
										</Truncate>
									</Text>
								</Flex>
								<Box pb={3}>
									<Text ml={['3px', '6px']} p={0} pb={'2px'} fontSize={'10px'}  fontWeight={600}>{name}</Text>
									<Text ml={['3px', '6px']}  fontSize={'10px'} fontWeight={600} color={'metaText'}>{date}</Text>
								</Box>
							</Wrapper>
						</Card>
					</TitleLink>
					{this.state.open ? this.renderModalData() : null}
				</div>
			);
		}
	}
}

export default withFirebase(PinnedPost);

